module.exports = __webpack_public_path__ + "img/gb75.prt.00910487.jpg";